// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IGetFlatTourBookingScheduleRequest,
  TGetFlatTourBookingScheduleModel,
  IMappers,
  TGetFlatTourBookingScheduleResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetFlatTourBookingScheduleResponse } from '../../entities/Models/GetFlatTourBookingScheduleResponse';

export function createGetFlatTourBookingScheduleModel(
  parameters: IGetFlatTourBookingScheduleRequest,
): TGetFlatTourBookingScheduleModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'newbuilding-flat-tour-booking',
    pathApi: '/v1/get-flat-tour-booking-schedule',
    response: {
      200: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetFlatTourBookingScheduleOptions<TResponse200> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200>;
  parameters: IGetFlatTourBookingScheduleRequest;
}

export async function fetchGetFlatTourBookingSchedule<TResponse200>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetFlatTourBookingScheduleOptions<TResponse200>): Promise<
  FetchResponse<TGetFlatTourBookingScheduleResponse> | TResponse200
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetFlatTourBookingScheduleModel(parameters),
    config,
  )) as FetchResponse<TGetFlatTourBookingScheduleResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetFlatTourBookingScheduleResponse, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetFlatTourBookingScheduleResponse>;
}
